import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { LocalLoginComponent } from './local-login.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    GalaxyFormFieldModule,
  ],
  declarations: [LocalLoginComponent],
  exports: [LocalLoginComponent],
  providers: [],
})
export class LocalLoginModule {}
